import * as React from "react";
import { Typography, WithStyles, withStyles } from "@material-ui/core";
import Caret from "../Caret/Caret";
import QuotationsList from "../QuotationsList/QuotationsList";
import { styles } from "./CustomerQuotations.style";
import { User } from "../../models/User.model";
import { Customer } from "../../types/Customer";
import { ActionHistory } from "../../types/ActionHistory";
import { Quotation } from "../../types/Quotation";
import { sortBy } from "lodash";

type CustomerQuotationsProps = {
    advisor: User;
    customer: Customer;
    onActionPerformed(quotation: Quotation, actionHistory: ActionHistory);
};

class CustomerQuotations extends React.Component<CustomerQuotationsProps & WithStyles<typeof styles>> {

    public render() {

        const quotations = sortBy(this.props.customer.quotations, (a) => { return new Date(a.creationDate); });
        const quotationsList = quotations.map((q) => {
            return {
                quotation: q,
                customer: this.props.customer
            };
        });

        const {classes, theme} = this.props;

        return (
            <div className="CustomerQuotations">
                <Typography className={classes.title} variant="title">Propositions et Adhésions</Typography>
                <Caret color={theme.palette.primary.main} variant="thick" top={1} bottom={3}/>
                <QuotationsList
                    onActionPerformed={this.props.onActionPerformed}
                    advisor={this.props.advisor}                    
                    quotationsList={quotationsList}
                />
            </div>
        );
    }

}

export default withStyles(styles, {withTheme: true})(CustomerQuotations);


// WEBPACK FOOTER //
// ./src/components/CustomerQuotations/CustomerQuotations.tsx